
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from 'sonner';
import "./App.css";
import HomePage from "./Components/HomePage/HomePage";
import Footer from "./Components/Footer/Footer";
import ContactPage from "./Components/ContactPage/ContactPage";
import AboutPage from "./Components/AboutPage/AboutPage";
import ResidentialPage from "./Components/ServicesPages/ResidentialPage";
import CommercialPage from "./Components/ServicesPages/CommercialPage";
import GuttersPage from "./Components/ServicesPages/GuttersPage";
import SidingPage from "./Components/ServicesPages/SidingPage";
import WindowsPage from "./Components/ServicesPages/WindowsPage";
import ProjectsPage from "./Components/ProjectsPage/ProjectsPage";
import SuccessPage from "./Components/ContactPage/SuccessPage";
import ReviewsPage from "./Components/ReviewsPage/ReviewsPage";
import Header from "./Components/MainHeader/Header";
import OurTeamPage from "./Components/OurTeamPage/OurTeamPage";
import MainLayout from "./Components/ColumbusPage/MainLayout";
import DublinLayout from "./Components/DublinPage/DublinLayout";
import HilliardLayout from "./Components/HilliardPage/HilliardLayout";
import Powell from "./Components/PowellPage/Powell";
import Marysville from "./Components/Marysville/Marysville";
import Reynoldsburg from "./Components/Reynoldsburg/Reynoldsburg";
import Blacklick from "./Components/Blacklick/Blacklick";
import Gahanna from "./Components/Gahanna/Gahanna";
import Delaware from "./Components/Delaware/Delaware";


import 'bootstrap/dist/css/bootstrap.min.css';
import 'glightbox/dist/css/glightbox.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';



function App() {
    return (
        <BrowserRouter>
            <Toaster richColors position="top-center" closeButton />
            <Header />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route
                    path="/residential-roofing"
                    element={<ResidentialPage />}
                />
                <Route
                    path="/commercial-roofing"
                    element={<CommercialPage />}
                />
                <Route path="/siding-enhancements" element={<SidingPage />} />
                <Route path="/gutter-systems" element={<GuttersPage />} />
                <Route path="/window-services" element={<WindowsPage />} />
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/success-page" element={<SuccessPage />} />
                <Route path="/our-team" element={<OurTeamPage />} />
                <Route path="location/columbus-ohio" element={<MainLayout />} />
                <Route path="location/dublin-ohio" element={<DublinLayout />} />
                <Route path="location/hilliard-ohio" element={<HilliardLayout />} />
                <Route path="location/powell-ohio" element={<Powell/>} />
                <Route path="location/marysville-ohio" element={<Marysville/>} />
                <Route path="location/reynoldsburg-ohio" element={<Reynoldsburg/>} />
                <Route path="location/blacklick-ohio" element={<Blacklick/>} />
                <Route path="location/gahanna-ohio" element={<Gahanna/>} />
                <Route path="location/delaware-ohio" element={<Delaware/>} />

                {/* F:\uk client akash\frontend-master\src\Components\.js */}

                <Route path="*" element={<HomePage />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    );
}

export default App;
